import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "children", "x", "y"];
import clsx from "clsx";
import React from "react";
import { createMemoClass } from "../create-memo-class";
import { jsx as _jsx } from "react/jsx-runtime";
export var Padding = props => {
  var {
    className,
    children,
    x,
    y
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classes = usePaddingClass({
    x,
    y
  });
  return /*#__PURE__*/_jsx("div", _extends({
    className: clsx(classes, className)
  }, rest, {
    children: children
  }));
};
var usePaddingClass = createMemoClass(props => {
  var xs = {
    "2": "px-2",
    "4": "px-2 lg:px-4",
    "8": "px-4 lg:px-8",
    "16": "px-8 lg:px-16"
  };
  var ys = {
    "2": "py-2",
    "4": "py-2 lg:py-4",
    "8": "py-4 lg:py-8",
    "16": "py-8 lg:py-16"
  };
  var classes = clsx(xs[props.x], ys[props.y]);
  return classes;
});
//# sourceMappingURL=padding.js.map